import React from 'react';
import { WebLayout } from '../components/web-layout';
import { Spinner } from '../components/spinner';
import { API } from '../../utils/AxiosInstance';

export interface Props {
    match: any
}

interface State {
    isLoading: boolean
    tokenError: boolean
}

export class Confirm extends React.Component<Props, State> {

    state: State = {
        isLoading: true,
        tokenError: false
    }

    async componentDidMount() {
        try {
            await API.post('/pow_registrations/confirm', { token: this.props.match.params.token });
            this.setState({ isLoading: false });
        } catch (e) {
            this.setState({ tokenError: true, isLoading: false })
        }
    }

    render() {
        
        const { isLoading, tokenError } = this.state;
        return (
            <WebLayout>
                {
                    isLoading ?
                    <div className='text-center'>Verifying please wait <Spinner /></div> :
                    tokenError ?
                    <TokenError /> :
                    <p className='text-center'>Email successfully verified.</p>
                }
                <br />
                <br />
            </WebLayout>
        )
    }

}

const TokenError = () => (
    <div>
        <p className='text-center'>Confirmation url has been expired. Please register again.</p>
    </div>
);